import type { ContactRequestBody, Workspace } from '@ditto/shared';
import { useMutation } from '@tanstack/react-query';
import { useAuthenticatedClient, useProtectedQuery } from './useApi';

export const useWorkspacesApi = () => {
  const { client } = useAuthenticatedClient(false);

  return useProtectedQuery({
    queryKey: ['workspaces'],
    queryFn: async () => {
      const response = await client.workspaces.getUserWorkspaces();

      if (response.status === 200) {
        return response.body as Workspace[];
      }
      throw new Error('Failed to fetch workspaces');
    },
    retry: 1,
  });
};

export const useWorkspacesForSidebarApi = () => {
  const { client } = useAuthenticatedClient(false);

  return useProtectedQuery({
    queryKey: ['workspaces-sidebar'],
    queryFn: async () => {
      const response = await client.workspaces.getUserWorkspacesForSidebar();

      if (response.status === 200) {
        return response.body as Workspace[];
      }
      throw new Error('Failed to fetch workspaces for sidebar');
    },
    retry: 1,
  });
};

export const useSendContactRequestApi = () => {
  const { client } = useAuthenticatedClient(false);

  return useMutation({
    mutationFn: async (data: ContactRequestBody) => {
      const response = await client.workspaces.sendContactRequest({
        body: data,
      });
      if (response.status === 200) {
        return response.body;
      }
      throw new Error('Failed to send contact request');
    },
  });
};
